import React from "react";
import Tienda from "./components/Tienda";
function App() {
  return (
    <div>
      <Tienda/>
    </div>
  );
}

export default App;
 